import { networkType } from "@/config";

const ADDRESS_MAP = {
  testnet: {
    AirdropPool: "0x2FD13CDD47E4152eBF2227013cA661707E2c79EF",
    stSPON: "0xCCB18D7BE64B4294e17833961771C837974CD98c",
    ThawingPool: "0xc042f8d367E7a442f863F0e4DaBd86f61fB08ae9",
    SPON: "0x76e593392523243ACD38ceD87c2007F14483a86B",
    sponAirdropContract: "0x42AE6F0dB33D3a82dA5CF645a1Bebcf28cd0e81A",
    stSponVestingContract: "0x8B8B56420DeB6e02C250012660283Ff8993accbf",
  },
  mainnet: {
    AirdropPool: "0x2FD13CDD47E4152eBF2227013cA661707E2c79EF",
    stSPON: "0xCCB18D7BE64B4294e17833961771C837974CD98c",
    ThawingPool: "0xc042f8d367E7a442f863F0e4DaBd86f61fB08ae9",
    SPON: "0x080D43c2164AFdBc3712422CE78Ab902ccaB5CA1",
    sponAirdropContract: "0xb7A7Ae65A39385973285168d71F034369a96eF80",
    stSponVestingContract: "0xD9e5D96d604ECdd3cd87fd84Ea8b34f2FC656e40",
  },
};

export const AirdropPool = ADDRESS_MAP[networkType].AirdropPool;
export const stSPON = ADDRESS_MAP[networkType].stSPON;

export const ThawingPool = ADDRESS_MAP[networkType].ThawingPool;
export const SPON = ADDRESS_MAP[networkType].SPON;

export const sponAirdropContract = ADDRESS_MAP[networkType].sponAirdropContract;
export const stSponVestingContract =
  ADDRESS_MAP[networkType].stSponVestingContract;
